import React from 'react';
import { WebinarSchedule } from '@models/interfaces/mock_exam.interface';
import {
  ICurrencySymbols,
  currencySymbols,
} from '@utils/constants/mock-exam.constants';
import { levelName } from '@utils/helpers/levelName';
import { NumberToFormattedString } from '@utils/helpers/formatNumber';

export interface IWebinarItems {
  groupedItems: WebinarSchedule[][];
  sortedKey: string[];
}

const WebinarItems = ({ items }: { items: IWebinarItems }) => {
  return (
    <>
      <div className="font-black text-primary-navyblue text-xl leading-[35px] mb-4 max-lg:mb-6">
        Summary
      </div>
      <div className="flex flex-col gap-6 max-w-[450px] max-lg:max-w-[none]">
        {items.sortedKey.map(level_id => (
          <div className="flex flex-col gap-2 max-lg:gap-4" key={level_id}>
            <div className="text-neutral-eraser text-sm font-black">
              {levelName(parseInt(level_id), false) + ''.toUpperCase()}{' '}
            </div>
            {items.groupedItems[parseInt(level_id)].map(
              (item: WebinarSchedule) => (
                <>
                  {item.will_register == true && (
                    <div key={item.class_id} className="text-sm flex">
                      <div className="flex max-sm:flex-col">
                        <p className="w-[165px]">{`${item.level_name} ${item.subject_name} Webinar`}</p>
                        <p className="text-neutral-dust ml-2 max-sm:!ml-0">{`${item.class_date_display} @${item.class_time_start}`}</p>
                      </div>
                      <div className="font-medium text-right ml-auto">
                        {currencySymbols[
                          item.currency_code as keyof ICurrencySymbols
                        ] + NumberToFormattedString(item.price)}
                      </div>
                    </div>
                  )}
                </>
              ),
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default WebinarItems;
